var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.6327 94.1613C58.5476 95.2796 36.4525 95.2796 14.3674 94.1613C7.34844 93.7819 1.21808 87.6516 0.838676 80.6327C-0.279558 58.5476 -0.279558 36.4524 0.838676 14.3673C1.21808 7.34838 7.34844 1.21808 14.3674 0.838676C36.4525 -0.279559 58.5476 -0.279559 80.6327 0.838676C87.6516 1.21808 93.7819 7.34838 94.1613 14.3673C95.2796 36.4524 95.2796 58.5476 94.1613 80.6327C93.7819 87.6516 87.6516 93.7819 80.6327 94.1613Z",
    fill: "#28AD7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9059 22.614V69.6298H25.29V74.8515H35.7335V69.6298H33.1176V56.5704H67.074C68.5118 56.5704 69.6899 55.4022 69.6899 53.9545V27.8358C69.6899 26.398 68.5217 25.2199 67.074 25.2199H33.1176V22.604H27.8959L27.9059 22.614ZM38.3494 30.4516V35.6734H43.5712V30.4516H48.7929V35.6734H54.0146V30.4516H59.2364V35.6734H64.4582V40.8951H59.2364V46.1169H64.4582V51.3387H59.2364V46.1169H54.0146V51.3387H48.7929V46.1169H43.5712V51.3387H38.3494V46.1169H33.1276V40.8951H38.3494V35.6734H33.1276V30.4516H38.3494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flagIcon.20179a3ae1e547d9e3c43e5cff28081c.svg";
export { ForwardRef as ReactComponent };